import { createEventEmitter } from "../utils/createEventEmitter.js";
class FloatingTreeStore {
  nodesRef = {
    current: []
  };
  events = createEventEmitter();
  addNode(node) {
    this.nodesRef.current.push(node);
  }
  removeNode(node) {
    const index = this.nodesRef.current.findIndex((n) => n === node);
    if (index !== -1) {
      this.nodesRef.current.splice(index, 1);
    }
  }
}
export {
  FloatingTreeStore
};
//# sourceMappingURL=FloatingTreeStore.js.map
